import { redirectToSavedSearchRoute } from '#/modules/search/routing/search.routes';
import { userDashboardApiIsomorphicFetchSavedSearch } from '#/modules/userDashboard/api/savedSearch/userDashboardApiIsomorphicFetchSavedSearch';
import { NotFoundPageLoadable } from '#/pages/NotFound/NotFoundPageLoadable';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistNotFound } from '#/routing/utils/idealistNotFound';

import { SavedSearchRedirectPageLoadable } from './SavedSearchRedirectPageLoadable';

export async function loader({
  request,
  context,
  params: { savedSearchId },
}: HorizonAppRouteLoaderArgs<typeof redirectToSavedSearchRoute>) {
  const [savedSearch] = await Promise.all([
    userDashboardApiIsomorphicFetchSavedSearch({ request, context })(
      savedSearchId,
    ).catch(() => null),
    SavedSearchRedirectPageLoadable.load(),
  ]);

  if (!savedSearch) return idealistNotFound({ savedSearch });

  return { savedSearch };
}

export default function SavedSearchRedirectHorizonRoute({
  loaderData: { savedSearch },
}: HorizonAppRouteComponentProps<typeof loader>) {
  if (!savedSearch) return <NotFoundPageLoadable />;

  return <SavedSearchRedirectPageLoadable savedSearch={savedSearch} />;
}
